import Vue from 'vue';

const state = {
  editing: null,
  configs: [],
};

const mutations = {
  set(currentState, configs) {
    currentState.configs = configs;
  },

  setEditing(currentState, config) {
    Vue.set(currentState, 'editing', config);
  },
};

export { mutations, state };
